import type { ProjectItem } from '@customink/project-service-react-components';

export function havePositiveQuantity(items: ProjectItem[]) {
  const totalQuantity = items.reduce(
    (acc, item) => acc + (item?.totalQuantity || 0),
    0,
  );
  return totalQuantity > 0;
}
